import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import configureStore from './CreateStore';
import rootSaga from '../sagas/';
import ReduxPersist from '../config/ReduxPersist';

/* ------------- Assemble The Reducers ------------- */
export const reducers = combineReducers({
  // Navigation state (will be implemented later)
  nav: require('./NavigationRedux').reducer,
  
  // Authentication
  login: require('./LoginRedux').reducer,
  register: require('./RegisterRedux').reducer,
  forgotPassword: require('./ForgotPasswordRedux').reducer,
  logout: require('./LogoutRedux').reducer,
  getMe: require('./GetMeRedux').reducer,
  
  // User Management
  updateProfilePic: require('./UpdateProfilePicRedux').reducer,
  changePassword: require('./ChangePasswordRedux').reducer,
  updateUserLocale: require('./UpdateUserLocaleRedux').reducer,
  updateNotificationToken: require('./UpdateNotificationTokenRedux').reducer,
  updateUserNotificationSettings: require('./UpdateUserNotificationSettingsRedux').reducer,
  
  // Children Management
  getChildren: require('./GetChildrenRedux').reducer,
  
  // Current Settings (for child switching)
  currentSettings: require('./CurrentSettingsRedux').reducer,
  
  // Goals & Progress
  attemptGoal: require('./AttemptGoalRedux').reducer,
  updateNotesOfGoal: require('./UpdateNotesOfGoalRedux').reducer,
  uploadImageToGoal: require('./UploadImageToGoalRedux').reducer,
  deleteImageFromGoal: require('./DeleteImageFromGoalRedux').reducer,
  gallery: require('./GalleryRedux').reducer,
  
  // Appointments
  getMyAppointments: require('./GetMyAppointmentsRedux').reducer,
  getAppointmentCategories: require('./GetAppointmentCategoriesRedux').reducer,
  getAppointmentTimeslots: require('./GetAppointmentTimeslotsRedux').reducer,
  getTimeslots: require('./GetTimeslotsRedux').reducer,
  getTimeslotsThirtyDay: require('./GetTimeslotsThirtyDayRedux').reducer,
  bookAppointmentTimeslot: require('./BookAppointmentTimeslotRedux').reducer,
  
  // Leave Management
  leave: require('./LeaveRedux').reducer,
  applyLeave: require('./ApplyLeaveRedux').reducer,
  updateLeave: require('./UpdateLeaveRedux').reducer,
  cancelLeave: require('./CancelLeaveRedux').reducer,
  getLeave: require('./GetLeaveRedux').reducer,
  getListLeave: require('./GetListLeaveRedux').reducer,
  getLeavesCancel: require('./GetLeavesCancelRedux').reducer,
  
  // Make-up Sessions
  applyMake: require('./ApplyMakeRedux').reducer,
  updateMake: require('./UpdateMakeRedux').reducer,
  cancelMake: require('./CancelMakeRedux').reducer,
  getMake: require('./GetMakeRedux').reducer,
  getMakeUpSession: require('./GetMakeUpSessionRedux').reducer,
  createMakeUpSession: require('./CreateMakeUpSessionRedux').reducer,
  getLeavesMakeUpSession: require('./GetLeavesMakeUpSessionRedux').reducer,
  
  // Withdrawals
  applyWithdrawal: require('./ApplyWithdrawalRedux').reducer,
  getWithdrawal: require('./GetWithdrawalRedux').reducer,
  createWithdrawals: require('./CreateWithdrawalRedux').reducer,
  deleteWithdrawal: require('./DeleteWithdrawalRedux').reducer,
  
  // File Management
  uploadFile: require('./UploadFileRedux').reducer,
  uploadMake: require('./UploadMakeRedux').reducer,
  deleteFile: require('./DeleteFileRedux').reducer,
  deleteMake: require('./DeleteMakeRedux').reducer,
  deleteLeave: require('./DeleteLeaveRedux').reducer,
  getFile: require('./GetFileRedux').reducer,
  getFileDownload: require('./GetFileDownloadRedux').reducer,
  
  // Calendar & Events
  getCalendarEvents: require('./GetCalendarEventsRedux').reducer,
  
  // Announcements
  getAnnouncements: require('./GetAnnouncementsRedux').reducer,
  seenAnAnnouncement: require('./SeenAnAnnouncementRedux').reducer,
  announcementIndividual: require('./AnnouncementIndividualRedux').reducer,
  
  // Other
  getAppointmentTimeslotsNew: require('./GetAppointmentTimeslotsNewRedux').reducer,
  getCheckSickNote: require('./GetCheckSickNoteRedux').reducer,
  getCheckAvailable: require('./GetCheckAvailableRedux').reducer,
  getListHistory: require('./GetListHistoryRedux').reducer,
  getTypes: require('./GetTypesRedux').reducer,
});

export default () => {
  let finalReducers: any = reducers;
  
  // If rehydration is on use persistReducer otherwise default combineReducers
  if (ReduxPersist.active) {
    const persistConfig = {
      ...ReduxPersist.storeConfig,
      storage: require('redux-persist/lib/storage').default,
    };
    finalReducers = persistReducer(persistConfig, reducers as any);
  }

  const { store, sagasManager, sagaMiddleware, persistor } = configureStore(finalReducers, rootSaga);

  // Hot reloading for development (commented out for now)
  // if (module.hot) {
  //   module.hot.accept(() => {
  //     const nextRootReducer = require('./').reducers;
  //     store.replaceReducer(nextRootReducer);

  //     const newYieldedSagas = require('../sagas').default;
  //     sagasManager.cancel();
  //     sagasManager.done.then(() => {
  //       sagasManager = sagaMiddleware.run(newYieldedSagas);
  //     });
  //   });
  // }

  return { store, persistor };
};
